module.exports = __webpack_public_path__ + "img/DR of congo.a7e48de7.jpg";